import { render, staticRenderFns } from "./asset-group-category-boxes.vue?vue&type=template&id=b75bcf02&scoped=true&"
import script from "./asset-group-category-boxes.vue?vue&type=script&lang=js&"
export * from "./asset-group-category-boxes.vue?vue&type=script&lang=js&"
import style0 from "./asset-group-category-boxes.vue?vue&type=style&index=0&id=b75bcf02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b75bcf02",
  null
  
)

export default component.exports